import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileType'
})
export class FileTypePipe implements PipeTransform {
    transform(fileName: string) {
        let extension;
        extension = fileName.split('.').pop();
        if (extension === 'txt') {
            return 'text.svg';
        } else if (extension === 'gif' || extension === 'jpg' || extension === 'png' || extension === 'jpeg') {
            return 'image.svg';
        } else if (extension === 'docx' || extension === 'doc') {
            return 'word.svg';
        } else if (extension === 'xlsx' || extension === 'xls') {
            return 'excel.svg';
        } else if (extension === 'pptx' || extension === 'ppt') {
            return 'powerpoint.svg';
        } else if (extension === 'pdf') {
            return 'pdf.svg';
        } else if (['eml', 'msg', 'pst', 'ost', 'mbox', 'dbx', 'nsf'].includes(extension)) {
            return 'email.svg';
        } else {
            return 'image.svg';
        }
    }
}
